import { useMutation } from 'react-query';
import managerCouponSevices from './managerCoupon.sevices';
import { notification } from 'antd';
import notificationError from '@/utils/functions/notificationError';
import { AxiosError } from 'axios';
import { useTaxCouponUpdateCode } from '../coupons/coupons.hooks';
import { validateCouponReturn } from './managerCoupons.errors';

export function useManagerCouponSend(couponId?: string) {
  const updateCode = useTaxCouponUpdateCode(false);

  return useMutation(managerCouponSevices.send, {
    async onSuccess(dataString) {
      await validateCouponReturn(dataString, updateCode.mutateAsync, couponId);
    },
    onError(error: AxiosError) {
      if (error.isAxiosError && error.message === 'Network Error') {
        notification.error({
          message:
            'O Middleware não está ativo, necessário ativa-lo para integração com o NeverStop',
        });
      } else {
        notificationError(error);
      }
    },
  });
}

export function useManagerCouponCancel() {
  return useMutation(managerCouponSevices.cancel, {
    onError(error: AxiosError) {
      if (error.isAxiosError && error.message === 'Network Error') {
        notification.error({
          message:
            'O Middleware não está ativo, necessário ativa-lo para integração com o NeverStop',
        });
      } else {
        notificationError(error);
      }
    },
  });
}

export function useManagerCouponPrint() {
  return useMutation(managerCouponSevices.print, {
    onSuccess() {
      notification.success({
        message: 'Cupom fiscal baixado com sucesso!',
      });
    },
    onError(error: AxiosError) {
      if (error.isAxiosError && error.message === 'Network Error') {
        notification.error({
          message:
            'O Middleware não está ativo, necessário ativa-lo para integração com o NeverStop',
        });
      } else {
        notificationError(error);
      }
    },
  });
}
